// VicTech #710:把「Need human」分页接进 ChatList,尽量不动 ChatList 本体。
// Need human 分页 = 既有的 label 路由 accounts/:id/label/need-human,assignee 固定「全部」;
// 列表、分页、状态筛选全部沿用 Chatwoot 原本的 label 清单逻辑。
import { computed, watch } from 'vue';
import wootConstants from 'dashboard/constants/globals';
import { NEED_HUMAN_LABEL } from './constants';

export const useNeedHumanTab = ({
  props,
  activeAssigneeTab,
  router,
  accountId,
}) => {
  const isNeedHumanView = computed(() => props.label === NEED_HUMAN_LABEL);

  // 进入 need-human 清单时同步把 assignee 切到「全部」(sync:要赶在 ChatList 自己的 label watch 抓资料之前)
  watch(
    isNeedHumanView,
    on => {
      if (on) activeAssigneeTab.value = wootConstants.ASSIGNEE_TYPE.ALL;
    },
    { immediate: true, flush: 'sync' }
  );

  // 在 Need human 分页时,原本三个分页都不亮
  const tabsActiveKey = computed(() =>
    isNeedHumanView.value ? '' : activeAssigneeTab.value
  );

  const openNeedHuman = () => {
    if (isNeedHumanView.value) return;
    router.push({
      name: 'label_conversations',
      params: { accountId: accountId.value, label: NEED_HUMAN_LABEL },
    });
  };

  // 在 Need human 分页点「我的/未分配/全部」→ 回一般清单并切到该分页。回 true = 已处理。
  const leaveTo = key => {
    if (!isNeedHumanView.value) return false;
    activeAssigneeTab.value = key;
    router.push({ name: 'home', params: { accountId: accountId.value } });
    return true;
  };

  return { isNeedHumanView, tabsActiveKey, openNeedHuman, leaveTo };
};
